/**
 * PDF-Aufrufe laufen mit `responseType: 'arraybuffer'` — kommt statt des PDFs
 * eine Fehlermeldung, steht auch sie als Bytes in `response.data`. `fehlertext`
 * und die Layoutprüfung erwarten JSON; hier wird es zurückverwandelt.
 */
export function lesbarerFehler(err: unknown): unknown {
  const antwort = (err as { response?: { data?: unknown } })?.response
  if (antwort && antwort.data instanceof ArrayBuffer) {
    try {
      antwort.data = JSON.parse(new TextDecoder().decode(antwort.data))
    } catch {
      antwort.data = {}
    }
  }
  return err
}
